import { Grid, Typography } from "@mui/material";
import { memo, useEffect, useState } from "react";

import { jwt, useSnackbar, products } from "../utils/index.js";
import { getOrderUser } from "../api/index.js";
import { Spinner } from "../tctt.js";
import CycloptCard from "../components/CycloptCard.js";

const HomeAuthenticated = () => {
	const { id: userId } = jwt.decode();
	const [order, setOrder] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const { error } = useSnackbar();
	
	const fetchData = async () => {
		try {
			setIsLoading(true);
			const data = await getOrderUser(userId);
			setOrder(data);
		} catch (err) {
			error(err);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, [userId]);

	return ([
		<Grid container direction="column" alignItems="flex-start" justifyContent="center">
			<Typography fontSize={26} fontWeight="bold">{"My Products"}</Typography>
			<Grid width="100%" container spacing={5} sx={{ padding: "15px 0px"}}>
				{products.filter((product) => product?.field === "always" || order?.[product?.field]).map((product) => (
					<CycloptCard key={product.id} isBought product={product} />
				))}
			</Grid>
			<Typography fontSize={26} fontWeight="bold">{"Other Products"}</Typography>
			<Grid width="100%" container spacing={5} sx={{ padding: "15px 0px"}}>
				{products.filter((product) => product?.field !== "always" && !order?.[product?.field]).map((product) => (
					<CycloptCard key={product.id} isBought={false} product={product} />
				))}
			</Grid>
		</Grid>,
		<Spinner open={isLoading} />
	]);
};

export default memo(HomeAuthenticated);
